// Patient-app runtime config. The API origin and Cognito pool/client come from Vite env. When no
// Cognito user pool is configured (local dev), the app runs in dev-session mode (cookie via
// /dev-login) so the full flow is testable without Cognito provisioned.
export const API_ORIGIN =
  (import.meta.env.VITE_API_ORIGIN as string | undefined)?.replace(/\/+$/, "") ||
  "http://localhost:8787";

// Cognito pool config (DRS-3 terraform). Region is informational — amplify v6 derives it from the
// pool id; the API side uses it to build the issuer/JWKS URLs.
export const COGNITO_REGION =
  (import.meta.env.VITE_COGNITO_REGION as string | undefined) || "us-west-2";

export const COGNITO_USER_POOL_ID =
  (import.meta.env.VITE_COGNITO_USER_POOL_ID as string | undefined) || "";

// This app's SPA client (cc-patient scope on the API side). USER_SRP_AUTH, no client secret.
export const COGNITO_CLIENT_ID =
  (import.meta.env.VITE_COGNITO_CLIENT_ID as string | undefined) || "";

export const COGNITO_ENABLED = COGNITO_USER_POOL_ID.length > 0 && COGNITO_CLIENT_ID.length > 0;

// Idle auto-logout for the patient shell (privacy). Matches the API session idle budget intent.
export const IDLE_TIMEOUT_MS = 30 * 60 * 1000;
